var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 14.6667V9.33337M3.33325 9.33337V2.66671M3.33325 9.33337L4.98037 9.00395C6.08072 8.78388 7.22132 8.8886 8.26321 9.30536C9.39224 9.75697 10.6349 9.8413 11.8146 9.54638L11.9575 9.51063C12.3743 9.40646 12.6666 9.03205 12.6666 8.60251V3.69117C12.6666 3.17079 12.1776 2.78897 11.6727 2.91517C10.5852 3.18704 9.43974 3.1093 8.39896 2.69299L8.26321 2.63869C7.22132 2.22194 6.08072 2.11721 4.98037 2.33728L3.33325 2.66671M3.33325 2.66671V1.33337",
    stroke: "currentColor",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.53cc96bf08585ad62c3cfda9bd22ea1b.svg";
export { ForwardRef as ReactComponent };